export default __webpack_public_path__ + "static/media/continue-arrow.61ff34c9.svg";